import React from 'react';
import StepsItem from './StepsItem';
import StepsSeparator from './StepsSeparator';

interface Props {
    className?: string
}

const defaultProps = {
    className: '',
}

type NativeAttrs = Omit<React.HTMLAttributes<any>, keyof Props>
export type BreadcrumbsProps = Props & typeof defaultProps & NativeAttrs


const Steps: React.FC<React.PropsWithChildren<BreadcrumbsProps>> = ({
    children,
    className,
}) => {

    const childrenArray = React.Children.toArray(children)
    const withSeparatorChildren = childrenArray.map((item, index) => {
        if (!React.isValidElement(item)) return item
        const last = childrenArray[index - 1]
        const lastIsSeparator = React.isValidElement(last) && last.type === StepsSeparator
        const currentIsSeparator = item.type === StepsSeparator
        if (!lastIsSeparator && !currentIsSeparator && index > 0) {
            return (
                <React.Fragment key={index}>
                    <StepsSeparator />
                    {item}
                </React.Fragment>
            )
        }
        return item
    })

    return (
        <nav className={`${className} flex items-baseline overflow-x-scroll flex-nowrap steps`}>
            {withSeparatorChildren}
            <style jsx>{`
            .steps::-webkit-scrollbar {
                display: none; /* Chrome, Safari and Opera */
            }
            .steps {
                -ms-overflow-style: none;  /* IE and Edge */
                scrollbar-width: none;  /* Firefox */
            }
          `}</style>
        </nav>
    )
}


type MemoStepsComponent<P = {}> = React.NamedExoticComponent<P> & {
    Item: typeof StepsItem
    Separator: typeof StepsSeparator
}
type ComponentProps = Partial<typeof defaultProps> &
    Omit<Props, keyof typeof defaultProps> &
    NativeAttrs

Steps.defaultProps = defaultProps

export default React.memo(Steps) as MemoStepsComponent<ComponentProps>